import { apiClient, get, post } from "@/_nucleo/api";
import { AnexoFinanceiroDetalhado, AnexoFinanceiroIdentificador, buildAnexoPrefix, ListFilesResponse } from "@FN";
import { useQuery } from "@tanstack/react-query";

/**
 * Busca todos os anexos no serviço Uploadthing
 */
async function fetchAllAnexosFinanceiro(): Promise<ListFilesResponse> {
  const { data } = await post<ListFilesResponse>(apiClient.avatar, `/listFiles`, {});
  return data;
}

/**
 * Busca detalhes de um anexo específico pela key
 */
async function fetchAnexoByKey(fileKey: string): Promise<AnexoFinanceiroDetalhado> {
  const { data } = await get<AnexoFinanceiroDetalhado>(apiClient.avatar, `/pollUpload/${fileKey}`);
  return data;
}

/**
 * Hook que retorna anexos completos filtrados por REC
 */
export function useAnexoFinanceiro(id: AnexoFinanceiroIdentificador | null) {
  return useQuery({
    queryKey: ["financeiro", "anexos", id],
    queryFn: async () => {
      if (!id) return;
      
      const allAnexos = await fetchAllAnexosFinanceiro()
      const prefix = buildAnexoPrefix(id);

      // pega só os do financeiro_${rec}
      const filtrados = allAnexos.files.filter((file) =>
        file.name.startsWith(prefix)
      )
      
      // mapeia para pegar os detalhes de cada um
      const detalhes = await Promise.all(
        filtrados.map((file) => fetchAnexoByKey(file.key))
      )

      return detalhes
    },
    enabled: !!id,
  })
}

/**
 * =======================
 * DELETAR
 * =======================
 */
/**
 * Deleta anexos no serviço avatar pelo fileKey
*/
async function fetchDeleteAnexoFinanceiro(fileKeys: string[]) {
  const { data } = await post(apiClient.avatar, `/deleteFiles`, {
    fileKeys,
  });
  return data;
}

/**
 * Função que busca e deleta todos anexos de um REC (uso direto com await)
 */
export async function deleteAnexosByIdentificador(id: AnexoFinanceiroIdentificador) {
  if (!id) return;

  const allAnexos = await fetchAllAnexosFinanceiro();

  const prefix = buildAnexoPrefix(id);

  // pega só os do financeiro_${rec}
  const filtrados = allAnexos.files.filter((file) =>
    file.name.startsWith(prefix)
  );
  
  // Envia os anexos filtrados (fileKeys) para deleção
  const fileKeys = filtrados.map((file) => file.key);
  if (fileKeys.length === 0) return;

  await fetchDeleteAnexoFinanceiro(fileKeys);
}